// websocket.js
let socket;

export const initializeWebSocket = (url) => {
  if (!socket) {
    socket = new WebSocket(url);

    socket.onopen = () => {
      console.log("WebSocket connection established");
    };

    socket.onmessage = (event) => {
      console.log("Message from server:", event.data);
    };

    socket.onclose = () => {
      console.log("WebSocket connection closed");
      socket = null; // Reset socket when closed
    };

    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
    };
  }
  return socket;
};

// Function to send a message via WebSocket
export const sendMessage = (message) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(message));
    console.log("Message sent to server:", message);
  } else {
    console.error("WebSocket is not connected");
  }
};

export const getWebSocket = () => {
  if (!socket) {
    console.warn("WebSocket is not initialized. Call initializeWebSocket first.");
  }
  return socket;
};
